import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

import { EventAttendeeRoles } from '../../global.constants';
import { CrewChipComponent } from '../crew-chip/crew-chip.component';

@Component({
  selector: 'app-crew-list',
  templateUrl: './crew-list.component.html',
  styleUrls: ['./crew-list.component.scss'],
  standalone: true,
  imports: [CommonModule, CrewChipComponent]
})
export class CrewListComponent implements OnInit {
  private _crew: any[] = [];
  @Input() set crew(value: any[]) {
    this._crew = value;
    this.sortCrew();
  }
  get crew(): any[] {
    return this._crew;
  }

  @Input() layout: 'column' | 'row' = 'column';
  @Input() displayFormat: 'lastname' | 'fullname' = 'lastname';

  sortedCrew: any[] = [];

  ngOnInit() {
    this.sortCrew();
  }

  private sortCrew() {
    if (!this.crew) {
      this.sortedCrew = [];
      return;
    }

    const uniqueCrew = new Map();
    for (const member of this.crew) {
      const id = member.user?.id || member.userId || member.id;
      if (id && !uniqueCrew.has(id)) {
        uniqueCrew.set(id, member);
      }
    }

    this.sortedCrew = Array.from(uniqueCrew.values()).sort((a, b) => {
      const aIsLead = this.isLead(a);
      const bIsLead = this.isLead(b);
      
      if (aIsLead && !bIsLead) return -1;
      if (!aIsLead && bIsLead) return 1;
      return 0;
    });
  }

  private isLead(c: any): boolean {
    return c.role === EventAttendeeRoles.crewLead || c.role === EventAttendeeRoles.assistantCrewLead;
  }
}
